import React from 'react';
import { Download, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { MAGAZINES } from '../mock/mock';
import { PageHero } from './BuyABook';

const Magazines = () => {
  return (
    <div className="fade-in">
      <PageHero title="Magazines" subtitle="Bold visual journals exploring culture, art, and the aesthetics of the unseen." />

      <section className="max-w-5xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-10">
          {MAGAZINES.map((m) => (
            <div key={m.title} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-500">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={m.cover} alt={m.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <p className="text-xs uppercase tracking-widest text-brand-brass">{m.issue}</p>
                <h3 className="font-serif text-3xl font-bold text-brand-ink mt-2">{m.title}</h3>
                <p className="text-brand-brown/80 mt-3 leading-relaxed">{m.desc}</p>
                <p className="text-sm text-brand-brass italic mt-4">{m.volume}</p>
                <div className="flex flex-wrap gap-3 mt-6">
                  <a href={m.download} target="_blank" rel="noopener noreferrer">
                    <Button className="bg-brand-gold hover:bg-brand-brass text-brand-ink hover:text-white rounded-full gap-2">
                      <Download className="h-4 w-4" /> Download
                    </Button>
                  </a>
                  <a href={m.link} target="_blank" rel="noopener noreferrer">
                    <Button variant="outline" className="border-brand-gold text-brand-ink hover:bg-brand-gold hover:text-white rounded-full gap-2">
                      <ExternalLink className="h-4 w-4" /> Read Online
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Magazines;
